module.exports = __webpack_public_path__ + "media/images/secondary_early_careers/cas-5f5e2813d0d20046bf53d1249b47ec38.png";